module.exports = __webpack_public_path__ + "img/rule-content-ar.fb8d01ee.png";